export default __webpack_public_path__ + "static/unsplash-f516d7e26a1f4a4ebdfa5dc06473369f.jpg";